<template>
  <div>
    <div class="row-collapse" v-bind:class="{ 'is-expand': hasEnabled() }">
      <Row :gutter="10" type="flex" class="grid-list-row mx-0 pl-30">
        <span
          class="row-expand"
          v-on:click="getLegDetails"
          v-bind:class="{ 'is-toggle': hasEnabled() }"
        ></span>
        <Col :span="3" align="middle" class="pointer" @click.native="openDetailSlider">
          <p>
            {{ indent.master_indent_no }}
            <small>
              {{
              $moment(indent.created_at).format("DD MMM YYYY")
              }}
            </small>
          </p>
        </Col>
        <Col :span="3" align="middle" class="pointer" @click.native="openDetailSlider">
          <span :class="getMasterStatusColor(indent.status)">
            {{statusName(indent.status)}}
          </span>
          <span class="badge badge-bottom" v-if="getMasterIndentIcon">
            <svgicon :name="getMasterIndentIcon" width="10" height="10" />
          </span>
        </Col>
        <Col :span="4" align="middle" class="pointer" @click.native="openDetailSlider">
          <p>{{ indent.destination.city }}</p>
        </Col>
        <Col :span="3" align="middle" class="pointer" @click.native="openDetailSlider">
          <p>
            {{incoTermName[indent.sub_type]}}
            <small>{{ indent.freight_forwarder && indent.freight_forwarder.name }}</small>
          </p>
        </Col>
        <Col align="middle" class="col-push text-right">
          <Popover
            placement="bottom"
            width="420"
            class="link-action"
            popper-class="popover-list bordered"
            :value="showContainer">
            <div class="popover-wrapper">
              <div class="popover-title">
                {{ isAirIndent ? 'Shipment booked' : 'Container Booking' }}
                <i class="close" @click="closeContainer">
                  <svgicon name="cancelblack-trans" width="12" height="12" />
                </i>
              </div>
              <div class="popover-body p-0">
                <Form :inline="true" class="form-default form-multi" v-if="isAirIndent">
                   <FormItem  v-for="shipment in airShipmentFields" v-bind:key="shipment.id" :label="shipment.label" :required="shipment.isRequired">
                    <Input v-if="shipment.input_type === 'text'" :placeholder="shipment.placeholder" v-model="containerDetails[`${shipment.id}`]"></Input>
                    <DatePicker
                      v-else
                      v-model="containerDetails[`${shipment.id}`]"
                      type="date"
                      prefix="false"
                      :placeholder="shipment.placeholder"
                      :picker-options="pickerOptions">
                    </DatePicker>
                  </FormItem>
                </Form>
                 <Form :inline="true" class="form-default form-multi" v-else>
                   <FormItem  v-for="field in containerFields" v-bind:key="field.id" :label="field.label" :required="field.isRequired">
                    <Input v-if="field.input_type === 'text'" :placeholder="field.placeholder" v-model="containerDetails[`${field.id}`]"></Input>
                    <DatePicker
                      v-else-if="field.input_type === 'date'"
                      v-model="containerDetails[`${field.id}`]"
                      type="date"
                      prefix="false"
                      :placeholder="field.placeholder"
                      :picker-options="pickerOptions">
                    </DatePicker>
                    <Select v-else
                      :placeholder="field.placeholder" v-model="containerDetails[`${field.id}`]">
                      <Option
                        v-for="item in field.dropdownList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </Option>
                    </Select>
                  </FormItem>
                </Form>
                <div class="popover-inner" v-if="$hasPermission('update_container_info')">
                  <div class="popover-doc">
                    <label>{{getAttachmentField}}<span  v-if="!isImportIndent && !isAirIndent" class="text-red">*</span></label>
                     <AttachmentsMin
                      :attachments="containerDetails.containerAttachments"
                      :showRemoveDocuments="showRemoveDocuments"
                      v-on:addAttachments="$emit('addAttachments',$event, indent)"
                      @removeAttachments="$emit('removeAttachments',$event, indent)" />
                  </div>
                </div>
              </div>
              <div class="popover-footer pt-0 mt-15">
                <Button type="primary" size="mini" @click="containerSumbit">
                  Submit
                </Button>
              </div>
            </div>
           <span slot="reference">
              <!-- Export Indent Conatiner update-->
              <span class="link-action"
                @click="getContainerDetails" v-if="![1,3].includes(indent.status) &&
                  $hasPermission('update_container_info') && !isImportIndent && !isLclMovement">
                <svgicon name="icon_vehicle" width="10" height="10" :original="true" />
                {{ isAirIndent ? 'Shipment' : 'Container' }}
              </span>
            </span>
          </Popover>
          <!-- Import Indent Accept-->
          <span class="link-action"
            @click="acceptMasterIndent" v-if="indent.status==1 && $hasPermission('update_indent_status') && isImportIndent && $hasPermission('update_container_info')">
            <svgicon name="accept" width="10" height="10" :original="true" />
            Accept
          </span>
          <!-- Export Indent Accept-->
          <span class="link-action"
            @click="acceptMasterIndent" v-if="indent.status==1 && $hasPermission('update_indent_status') && !isImportIndent">
            <svgicon name="accept" width="10" height="10" :original="true" />
            Accept
          </span>
          <span class="link-action"
            @click="$emit('rejectMasterIndent')" v-if="indent.status==1 && $hasPermission('update_indent_status')">
            <svgicon name="reject" width="10" height="10" :original="true" />
            Reject
          </span>
          <span class="link-action" v-on:click="$emit('redirectToMasterDocument',indent.master_indent_no)">
            <svgicon name="icon-action-documents" width="10" height="10" :original="true" />
            Documents
          </span>
        </Col>
      </Row>
      <div class="nested-list" v-if="hasEnabled()">
        <div v-if="isChildLegLoading">
          Loading....
        </div>
        <template
          v-else
          v-for="legIndent in childLegs"
        >
          <div
            v-for="childIndent in legIndent.childs"
            v-bind:key="childIndent.id"
            class="nested-list-item"
          >
            <road-listing-row :order="childIndent" v-if="legIndent.type === 1"
              @openSlider="$emit('openChildDetailSlider',childIndent,legIndent.type)"
              @indentMarkDeliver="$emit('indentMarkDeliver', $event, childIndent.order_number)"
              @handedToTransporter="$emit('handedToTransporter', $event, childIndent.order_number)"
              @redirectToDocument="$emit('redirectToDocument', childIndent.order_number)"
              :markAsDeliveredPopover="markAsDeliveredPopover && selectedChildIndent.id == childIndent.id"
              :handedToTransPopover="handedToTransPopover && selectedChildIndent.id === childIndent.id"
              :clientConfiguations="configurations"
              :clientSettings="shipperDetails && shipperDetails.settings"
              :lrForTruckout="shipperDetails && shipperDetails.lr_for_truck_out"
              :isImportIndent="isImportIndent"
              @openCloseMarkAsDeliveredPopover="openCloseMarkAsDeliveredPopover($event, childIndent)"
              @openCloseHandedToTransPopover="openCloseHandedToTransPopover($event, childIndent)"/>
            <ocean-listing-row
              :containerDetails="getContaineInformation"
              :isImportIndent="isImportIndent"
              :oceanLegAttachmentsMeta="oceanLegAttachmentsMeta"
              :order="childIndent" v-if="legIndent.type === 2 || legIndent.type === 3"  @generic-action-submit="genericActionSubmit"
              :containerTypeList="containerTypeList"
              :searchPortList="searchPortList"
              :showRemoveDocuments="showRemoveDocuments"
              @removeAttachments="removeAttachments"
              :searchDropDownInput="searchDropDownList"
              @loadDropDownData="fetchDropDown"
              @openSlider="$emit('openChildDetailSlider',childIndent,legIndent.type)"
              @addAttachments="addAttachments"
              @fetch-container-type-list="$emit('fetch-container-type-list', indent.client_id, $event)"
              @fetch-port-list="$emit('fetch-port-list', indent.client_id, $event)"
              @fetch-drop-down-list="fetchDropDownRemote"
              />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { Fragment } from "vue-fragment";
import AttachmentsMin from "@common/components/AttachmentsMin";
import RoadLegRow from "@common/components/eximlist/list/RoadLegRow";
import OceanlegRow from "@common/components/eximlist/list/OceanlegRow";
import { containerAirFormFields, containerFormFields } from '@common/constants/eximConstants';
import { masterEximStatus, importExportType, eximMovementTypeDetails, legType, eximMovementType } from 'pando-constants';

export default {
  components: {
    "road-listing-row": RoadLegRow,
    "ocean-listing-row": OceanlegRow,
    Fragment,
    AttachmentsMin,
  },
  props: {
    indent: {
      default: () => {},
      type: Object
    },
    showRemoveDocuments:{
      type: Boolean,
      default: false,
    },
    selectedMasterNo: {
      default: null,
      type: String
    },
    childLegs: {
      default: () => [],
      type: Array
    },
    isChildLegLoading: {
      default: false,
      type: Boolean
    },
    incoTermName: {
      default: () => {},
      type: Object
    },
    containerDetails:{
      default: () => ({}),
      type: Object
    },
    showContainer:{
      default: false,
      type: Boolean
    },
    masterOrderDetails: {
      default: () => {},
      type: Object,
    },
    childIndentDetails: {
      default: () => {},
      type: Object,
    },
    oceanLegAttachmentsMeta: {
     default: () => {},
      type: Object,
    },
    markAsDeliveredPopover:{
      default: false,
      type: Boolean
    },
    handedToTransPopover:{
      default: false,
      type: Boolean
    },
    configurations:{
      default: () => {},
      type: Object,
    },
    shipperDetails: {
      default: () => {},
      type: Object,
    },
    portsList:{
      default: () => {[]},
      type: Array
    },
    containerTypeList: {
      default: null,
      type: Array,
    },
    searchPortList: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      activeMasterNo: false,
      detailSlider: false,
      cancelIndent: false,
      masterEximStatus,
      selectedChildIndent: {},
      searchDropDownList: [],
      containerAirFormFields,
      containerFormFields,
      pickerOptions1: {
        disabledDate(time) {
          const date = new Date();
          return time.getTime() < new Date(date.setDate(date.getDate() - 1));
        },
      },
    };
  },
  computed: {
    isAirIndent () {
      return [4,5,6].includes(this.indent.movement_type);;
    },
    airShipmentFields() {
      const indentType = this.isImportIndent ? 'import' : 'export';
      const airMovement = this.indent.movement_type === 4 ? 4 : 5;
      return this.containerAirFormFields[indentType][airMovement] || [];
    },
    containerFields() {
      const indentType = this.isImportIndent ? 'import' : 'export';
      const fields = this.containerFormFields[indentType] || [];
      return fields.map(field => {
        const fieldDetails = Object.assign({},field);
        if(field.id === 'port_for_container_pickup') {
          fieldDetails.dropdownList = this.portsList;
        }
        return fieldDetails;
      })
    },
    getMasterIndentIcon() {
      let type = null;
      eximMovementTypeDetails.forEach((movement) => {
        if (this.indent.movement_type === movement.id) {
          type = movement.group_type;
        }
      });
      if (type) {
        if (type === legType.ROAD) {
          return 'icon-status-road';
        } else if (type === legType.OCEAN) {
          return 'icon-status-ship';
        } else if (type === legType.AIR) {
          return 'icon-status-air';
        }
      }
      return type;
    },
    isImportIndent() {
      return this.indent.type === importExportType.IMPORT;
    },
    getAttachmentField(){
      if(this.isImportIndent){
        return 'Shipping Order';
      }
      if(this.isAirIndent) {
        return this.indent.movement_type === eximMovementType.CARGO ?
          'Airway bill draft' : 'AWB / Label copy';
      }
      return 'Container Booking Document';
    },
    getPolField(){
      if(this.isImportIndent){
        return 'POL Cut off Date';
      }
      return 'Delivery Date for POL';
    },
    getContaineInformation() {
      const containerDetials = [];
      if (this.childLegs.length) {
        const roadLegs = this.childLegs.find(childLeg => childLeg.type === 1);
        if (roadLegs && roadLegs.childs && roadLegs.childs.length) {
          roadLegs.childs.forEach((_leg, ind) => {
            const obj = {
              sno: ind + 1,
              containerId: _leg.container ? _leg.container.id : null,
              containerName: _leg.container ? _leg.container.name : null,
              containerNumber: null,
            };
            containerDetials.push(obj);
          });
        }
      }
      return containerDetials;
    },
    isLclMovement() {
      return this.indent && this.indent.movement_type === 2;
    },
    async searchActionInput() {
      return this.searchDropDownList;
    },
  },
  methods: {
    pickerOptions(field) {
      if (field.isBackDateRequired) {
        return {}
      }
      return {
        disabledDate(time) {
          if((time instanceof Date)) {
            const date = new Date();
            return time.getTime() < new Date(date.setDate(date.getDate() - 1));
          }
          return {}
        },
      }
    },
    removeAttachments(file) {
      this.$emit('removeOceanLegAttachments', file);
     },
     async fetchDropDown(childIndent) {
      const hasField = childIndent && childIndent.action && childIndent.action.fields && childIndent.action.fields.length;
      if (hasField) {
        const dropDownDetail = childIndent.action.fields.find(_field => _field.input_type === '3');
        if (dropDownDetail) {
          const result = await this.$store.dispatch('exim/fetchDropDownInput', {
            url: dropDownDetail.api_endpoint,
            params: { client_id: this.indent.client_id },
          });
          this.searchDropDownList = result.map(sectionDetail => ({ id: sectionDetail[`${dropDownDetail.drop_down_fields.id_field}`], name: sectionDetail[`${dropDownDetail.drop_down_fields.display_field}`] }));
        }
      }
    },
    async fetchDropDownRemote({ queryValue, url, queryField }) {
      try {
        const params = { client_id: this.indent.client_id  };
        if (queryValue) {
          params[`${queryField}`] = queryValue;
        }
        this.searchDropDownList = await this.$store.dispatch('exim/fetchDropDownInput', {
          url,
          params,
        });
      } catch (error) {
        this.$error({ message: this.$getErr('EXIM_PORT_SEARCH_FAILS') });
      }
    },
    statusName (statusNo){
      return this.masterEximStatus.find(status => status.id === statusNo).label || '-'
    },
    getLegDetails() {
      this.activeMasterNo = !this.activeMasterNo;
      this.$emit("fetch-leg-indents", {
        indentNo: this.indent.master_indent_no,
        toggleStatus: this.activeMasterNo,
      });
      this.$emit("fetch-port-list", this.indent.client_id);
      this.$emit("fetch-container-type-list", this.indent.client_id);
    },
    getMasterStatusColor(statusNo){
      const color =  this.masterEximStatus.find(status => status.id === statusNo).color || 'status-green';
      return `status ${color}`;
    },
    openDetailSlider() {
      this.$emit('openDetailSlider');
    },
    hasEnabled() {
       return this.activeMasterNo && this.selectedMasterNo === this.indent.master_indent_no;
    },
    containerSumbit(){
      const fieldsConstants = this.isAirIndent ?
        this.airShipmentFields : this.containerFields;
      const requiredHasErrors = fieldsConstants.reduce(
      (attachment, item) => {
        if(item.isRequired) {
          if (!this.containerDetails[`${item.id}`]) {
          attachment.push(item.label);
        }
        }
        return attachment;
      },
      [],
    );
    if (requiredHasErrors.length) {
      const suffix = requiredHasErrors.length === 1 ? 'is required' :
        'are required';
      this.$errorMessage({
        message: `${requiredHasErrors.toString(' ')} ${suffix}`,
      });
      return true;
      }
      if(!this.isImportIndent && !this.isAirIndent &&
        (!this.containerDetails.containerAttachments ||
          !this.containerDetails.containerAttachments.length)) {
           this.$errorMessage({
            message: `${this.getAttachmentField} is required`,
          });
          return true;
      }
      this.$emit('containerSumbit', {indent: this.indent, containerDetails: this.containerDetails });
    },
    getContainerDetails(){
      this.$emit('getContainerDetails');
    },
    genericActionSubmit({ indentNo, values, actionOn }) {
      this.$emit('generic-action-submit', { indentNo, values, actionOn });
    },
    closeContainer(){
      this.$emit('closeContainerDetails');
    },
    addAttachments(file, indent, label) {
      this.$emit('oceanLegAttachment', file, indent, label);
    },
    openCloseMarkAsDeliveredPopover($event, indent){
      this.selectedChildIndent = indent;
      this.$emit('openCloseMarkAsDeliveredPopover',$event)
    },
    openCloseHandedToTransPopover($event, indent){
      this.selectedChildIndent = indent;
      this.$emit('openCloseHandedToTransPopover',$event)
    },
    acceptMasterIndent(){
      if(this.isImportIndent && !this.isLclMovement){
        this.$emit('importMasterIndentAccept');
      } else{
        this.$emit('acceptMasterIndent');
      }
    }
  }
};
</script>
